import React from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import InputText from '../../../../components/gdc-components-atoms-input-text';
import Label from '../../../../components/gdc-components-atoms-label';

import './styles.css';

const ProofOfOwnership = (props) => {
    return (
        <FormGroup id={props.id}>
            <Row className="proof-of-ownership mb-25">
                <Col lg={6} className="w-100-1326">
                    <InputText className="radio"
                        type="radio"
                        id="customer-validation-type-customer-number"
                        checked={props.customerNumberSelected}
                        onChange={props.customerNumberSelectedHandler}
                    />
                    <Label id="label-customer-number"
                        className="label-radio"
                        onClick={props.customerNumberSelectedHandler}>Identifix Customer Number</Label>
                </Col>
                <Col lg={6} className="w-100-1326">
                    <InputText className="radio"
                        type="radio"
                        id="customer-validation-type-credit-card"
                        checked={props.creditCardSelected}
                        onChange={props.creditCardSelectedHandler}
                    />
                    <Label id="label-credit-card"
                        className="label-radio"
                        onClick={props.creditCardSelectedHandler}>Last 4 - Credit Card Number</Label>
                </Col>
            </Row>
            <InputText type="text"
                tabIndex={props.tabIndex}
                className={props.isError ? "form-control striped-input input-error" : "form-control striped-input"}
                id="proof-of-owner-ship-input"
                value={props.proofOfOwnerShipValue}
                placeholder={props.proofOfOwnershipPlaceholder}
                onChange={props.proofOfOwnerShipValueChangedHandler}
                onKeyPress={props.onKeyPress} />
        </FormGroup>
    );
}

export default ProofOfOwnership;


// WEBPACK FOOTER //
// ./src/modules/account-connector/components/proof-of-ownership/index.js